"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateBaseScore = calculateBaseScore;
function calculateBaseScore(userAnswer, candidateAnswer) {
    if (userAnswer !== undefined && candidateAnswer !== undefined) {
        return Math.sign(userAnswer * candidateAnswer) + 0;
    }
    throw new Error("Undefined value received");
}
